import router from 'next/router';
import fetchNext from '@features/api/fetchNext';
import { TInspirationsTypesSlug } from '@features/cms/typescript';
import getPublicEnv from '@utils/getPublicEnv';
class NextInspirationsApi {
  private endpoints = {
    getArticlesByTag: (tags: string, type: TInspirationsTypesSlug = 'ideas') => `inspirations/${type}?tags=${tags}`,
    getArticles: (limit: number, type: TInspirationsTypesSlug = 'ideas') => `inspirations/${type}?limit=${limit}`
  };
  private static getLocale() {
    const isServerSide = typeof window === 'undefined';
    if (isServerSide) return process.env.DEFAULT_LOCALE;
    const {
      locale
    } = router;
    return locale || getPublicEnv('NEXT_PUBLIC_DEFAULT_LOCALE');
  }
  public async getArticlesWithTags(tagsId: number[], type: TInspirationsTypesSlug = 'ideas') {
    const method = 'GET';
    const {
      json
    } = await fetchNext(this.endpoints.getArticlesByTag(tagsId.toString(), type), {
      method
    }, NextInspirationsApi.getLocale());
    return json;
  }
  public async getArticles(limit: number, type: TInspirationsTypesSlug = 'ideas') {
    const method = 'GET';
    const {
      json
    } = await fetchNext(this.endpoints.getArticles(limit, type), {
      method
    }, NextInspirationsApi.getLocale());
    return json;
  }
}
export default new NextInspirationsApi();